import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * AppliedChip, the tiny ink counter on a filter drill row.
 *
 * CSS selector: `mobile/atoms.css` `.ds-applied-chip`.
 *
 * Doctrine: this counts applied filters, which are commands, so it is ink and
 * has no accent variant. It is informational chrome and stays a span, never a
 * button; the row around it owns the tap.
 */
export const AppliedChip = React.forwardRef(function AppliedChip({ className, ...rest }, ref) {
  return <span ref={ref} className={cn('ds-applied-chip', className)} {...rest} />;
});

export default AppliedChip;
